import { Box, Chip, LinearProgress, Stack, Typography } from "@mui/material";
import React from "react";

import type { AssigneeWorkloadRow } from "../../utils/crmOperationalDashboard.aggregate";

export type AssigneeWorkloadWidgetProps = {
  rows: AssigneeWorkloadRow[];
  loading?: boolean;
};

export const AssigneeWorkloadWidget = ({ rows, loading }: AssigneeWorkloadWidgetProps) => {
  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={600} gutterBottom>
        Assignee workload
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
        Active (non-done) tasks per assignee; progress relative to highest load.
      </Typography>
      {loading ? (
        <Typography variant="body2" color="text.secondary">
          Loading…
        </Typography>
      ) : !rows?.length ? (
        <Typography variant="body2" color="text.secondary">
          No active tasks
        </Typography>
      ) : (
        <Stack spacing={2}>
          {rows.map((row) => (
            <Box key={String(row.assigneeId)}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
                <Typography variant="body2" fontWeight={600} noWrap sx={{ maxWidth: "70%" }}>
                  {row.displayName}
                </Typography>
                <Stack direction="row" spacing={0.5} alignItems="center">
                  {row.overdueCount > 0 ? (
                    <Chip label={`${row.overdueCount} overdue`} size="small" color="error" variant="outlined" />
                  ) : null}
                  <Typography variant="caption" color="text.secondary">
                    {row.activeCount} active
                  </Typography>
                </Stack>
              </Stack>
              <LinearProgress
                variant="determinate"
                value={Math.round(row.progress * 100)}
                sx={{
                  height: 8,
                  borderRadius: 1,
                  bgcolor: "action.hover",
                  "& .MuiLinearProgress-bar": {
                    bgcolor: row.overdueCount > 0 ? "error.main" : "primary.main",
                  },
                }}
              />
            </Box>
          ))}
        </Stack>
      )}
    </Box>
  );
};
